import React from "react";
import { NormDetails } from "../..";

export default function DetailsTab({ normId, onActive }) {
	return <NormDetails normId={normId} onActive={onActive} />;
}
